const weekDaysMap = new Map([
  [0, "Dom"],
  [1, "Lun"],
  [2, "Mar"],
  [3, "Mie"],
  [4, "Jue"],
  [5, "Vie"],
  [6, "Sab"]
]);

const monthsBaseInfo = new Map([
  [1, { name: "Enero", amountOfDays: 31 }],
  [2, { name: "Febrero", amountOfDays: 28 }],
  [3, { name: "Marzo", amountOfDays: 31 }],
  [4, { name: "Abril", amountOfDays: 30 }],
  [5, { name: "Mayo", amountOfDays: 31 }],
  [6, { name: "Junio", amountOfDays: 30 }],
  [7, { name: "Julio", amountOfDays: 31 }],
  [8, { name: "Agosto", amountOfDays: 31 }],
  [9, { name: "Septiembre", amountOfDays: 30 }],
  [10, { name: "Octubre", amountOfDays: 31 }],
  [11, { name: "Noviembre", amountOfDays: 30 }],
  [12, { name: "Diciembre", amountOfDays: 31 }]
]);

const monthNames = new Map([
  [1, "Enero"],
  [2, "Febrero"],
  [3, "Marzo"],
  [4, "Abril"],
  [5, "Mayo"],
  [6, "Junio"],
  [7, "Julio"],
  [8, "Agosto"],
  [9, "Septiembre"],
  [10, "Octubre"],
  [11, "Noviembre"],
  [12, "Diciembre"]
]);

const odsEventNamesMap = new Map([
  [0, "XR"],
  [1, "C"],
  [2, "PL"],
  [3, "PNR"],
  [4, "I"],
  [5, "D"]
]);

export { weekDaysMap, monthsBaseInfo, monthNames, odsEventNamesMap };
